<template>
  <div v-if="!isMobile()" class="table-container">
    <table class="m-flex" aria-label="provider biography">
      <tbody>
      <tr class="nurse-edit" :id="'nurse-edit' + providerChild.licensenum">
        <td>
        <div :id="'nurseform' + providerChild.licensenum">
          <label for="nursefname">First Name:</label>
          <input
            type="text"
            id="nursefname"
            placeholder="*Required"
            :value="providerChild.firstname"
            class="field"
          />
          <label for="nurselname">Last Name:</label>
          <input
            type="text"
            id="nurselname"
            :value="providerChild.lastname"
            placeholder="*Required"
            class="field"
          />
          <label for="nraccount">Account Number:</label>
          <input
            type="text"
            id="nraccount"
            :value="providerChild.acountnumber"
            placeholder="*Required"
            class="field"
          />
          <label for="nursetype">Nurse Type:</label>
          <select class="field" id="nursetype" aria-placeholder="*Required">
            <option
              v-if="providerChild.licensetype"
              select="selected"
              :value="providerChild.licensetype"
            >
              Registred Nurse
            </option>
            <option v-else-if="!providerChild.licensetype" select="selected" value="selected">
              Select Nurse Type
            </option>
            <!--<option value="RN">Registred Nurse</option>-->
            <option value="LPN">Licensed Practical Nurse</option>
            <option value="CN">Cardic Nurse</option>
            <option value="CRNA">Certified Registered Nurse Anesthetist</option>
          </select>
          <label for="nraddress">Address:</label>
          <input type="text" id="nraddress" :value="providerChild.addr1" class="field" />
          <label for="nrcity">City:</label>
          <input type="text" id="nrcity" :value="providerChild.city" class="field" />
          <label for="nrstate">State:</label>
          <input type="text" id="nrstate" :value="providerChild.state" class="field" />
          <label for="nrzip">Zip:</label>
          <input type="text" id="nrzip" :value="providerChild.zip" class="field" />
          <label for="nrlicense">License Number:</label>
          <input
            type="text"
            id="nrlicense"
            :value="providerChild.licensenum"
            placeholder="*Required"
            class="field"
          />
          <label for="nrdob">Date of Birth:</label>
          <input
            type="date"
            id="nrdob"
            :value="providerChild.dob"
            placeholder="*Required"
            class="field"
          />
          <label v-if="providerChild.primaryphone" for="primephone">Primary Phone:</label>
          <input
            v-if="providerChild.primaryphone"
            type="phone"
            id="primephone"
            :value="providerChild.primaryphone"
            class="field"
          />
          <label v-if="providerChild.secondaryphone" for="secphone">Secondary Phone:</label>
          <input
            v-if="providerChild.secondarphone"
            type="phone"
            id="secphone"
            :value="providerChild.secondaryphone"
            class="field"
          />
          <label v-if="providerChild.socialnum" for="nrsocial">Social Security:</label>
          <input
            v-if="providerChild.socialnum"
            type="text"
            id="nrsocial"
            :value="providerChild.socialnum"
            placeholder="*Required"
            class="field"
          />
          <label v-if="providerChild.ncsbnid" for="nrnsbid">NBSID Number:</label>
          <input
            v-if="providerChild.ncsbnid"
            type="text"
            id="nrnsbid"
            :value="providerChild.ncsbnid"
            class="field"
          />
          <label for="nurseemail">Email:</label>
          <input
            type="email"
            id="nurseemail"
            :value="providerChild.email"
            placeholder="*Required"
            class="field"
          /><br /><br />
          <div class="btn-sec">
            <input
              type="button"
              class="btn btn-primary"
              value="Updte Nurse"
              id="updatenursebtn"
              @click="UpdateNurse($event, providerChild.licensenum)"
            />
            <input
              type="button"
              class="btn btn-secondary"
              value="Close"
              id="cancelnursebtn"
              @click="CancelUpdateNurse($event, providerChild.licensenum)"
            />
          </div>
        </div>
      </td>
      </tr>
      <tr class="nurse-card">
      <td>
        <div :id="'nursecard' + providerChild.licensenum">
          <tr>
            <td>
              <img src="@/assets/images/avatar-female.jpg" class="provider__avatar" />
            </td>
          </tr>
          <tr>
            <td class="provider__info capitalize">
              <font-awesome-icon :icon="['fas', 'map-market-alt']" class="icon" />
              <span v-if="providerChild.addr1">
                <b> Address:</b> {{ providerChild.addr1.toLowerCase() }}</span
              >
              <span v-else style="color: tomato">please pull the backend</span>
              <span v-if="providerChild.addr2"> , {{ providerChild.addr2.toLowerCase() }}</span>
              <span v-if="providerChild.city"> , {{ providerChild.city.toLowerCase() }}</span>
              <span v-if="providerChild.state"> , {{ providerChild.state.toUpperCase() }}</span>
              <span v-if="providerChild.zip"> , {{ providerChild.zip }}</span>
            </td>
          </tr>
          <tr v-if="providerChild.primaryphone">
            <td class="provider__info">
              <font-awesome-icon :icon="['fas', 'phone']" class="icon" /><b>Cell: </b
              ><a
                :id="patient.id"
                href="#callProvCell"
                @click="CallProviderCell($event, provider.pmid)"
                >{{ provider.primaryphone }}</a
              >
            </td>
            <td class="d-option" :id="'d-option' + provider.pmid">
              <div class="option-container">
                <div class="x-close">
                  <a href="#closeoption" @click="closeDOption($event)" id="d-itemclose"
                    >X</a
                  >
                </div>
                <div v-if="providerChild.primaryphone" class="option-item" id="option-item1">
                  <h4>SMS or Call Provider Cell</h4>
                  <span class="slabel">Call:</span>
                  <a href="#callprov" @click="callProvider(providerChild)">{{
                    providerChild.primaryphone
                  }}</a
                  ><br /><br />
                  <span class="slabel">Text:</span>
                  <a
                    href="#smsprov"
                    @click="
                      showTextProv(
                        $event,
                        providerChild.primaryphone,
                        patient.id,
                        provider.pmid
                      )
                    "
                    >{{ providerChild.primaryphone }}</a
                  ><br />
                </div>
              </div>
            </td>
            <td class="m-option" :id="'m-option' + provider.pmid">
              <div class="option-container">
                <div class="x-close">
                  <a href="#closeoption" @click="closeOption($event)" id="m-itemclose"
                    >X</a
                  >
                </div>
                <div v-if="providerChild.primaryphone" class="option-item" id="option-item1">
                  <h4>Call Nurse Primary</h4>
                  <a :href="'tel:' + providerChild.cell">{{ providerChild.primaryphone }}</a>
                </div>
                <div v-if="providerChild.cell" class="option-item" id="option-item1">
                  <h4>Text or Call Provider</h4>
                  <a :href="'tel:' + providerChild.primaryphone">{{
                    providerChild.primaryphone
                  }}</a>
                  <a :href="'sms:' + providerChild.primaryphone">{{
                    providerChild.primaryphone
                  }}</a>
                </div>
              </div>
            </td>
          </tr>
          <tr v-if="providerChild.email">
            <td class="provider__info capitalize">
              <font-awesome-icon :icon="['fas', 'inbox']" class="icon" />
              <span
                ><b>Email: </b
                ><a
                  href="#currentNurse"
                  @click="showEmailModule($event, provider, provider.pmid)"
                  >{{ provider.email }}</a
                ></span
              >
            </td>
          </tr>
          <!-- <tr v-if="provider.acountnumber">
                    <td class="provider__info capitalize">
                    <font-awesome-icon icon="arrow-right" class="icon"/>
                    <b>Account Number:</b><span :id="'accountnum'+provider.licensenum">{{ provider.acountnumber }}</span>
                    </td>
                </tr> -->
          <!-- <tr v-if="provider.licensetype">
                    <td class="provider__info capitalize">
                    <font-awesome-icon icon="arrow-right" class="icon"/>
                    <b>License Type:</b><span :id="'ltype'+provider.licensenum">{{ provider.licensetype }}</span>
                    </td>
                </tr> -->
          <tr v-if="providerChild.licensenum">
            <td class="provider__info">
              <!---<font-awesome-icon icon="phone" :id="'desktopTel'+patient.id" class="icon"/><b>Tel: </b><a href="#call" @click="CallProvider(provider)">{{ provider.tel }}</a>-->
              <font-awesome-icon :icon="['fas', 'phone']" class="icon" /><b>{{
                `${providerChild.state} License #: `
              }}</b
              ><a
                href="#verfiy"
                :id="'desktopLicense' + providerChild.licensenum"
                @click="VerifyNurse(providerChild)"
                >{{ `${providerChild.licensenum}` }}</a
              >{{ `, Exp. ${providerChild.licenseexpdate}` }}
            </td>
          </tr>
          <!-- <tr v-if="provider.licenseexpdate">
            <td class="provider__info">
              -<font-awesome-icon icon="phone" :id="'desktopTel'+patient.id" class="icon"/><b>Tel: </b><a href="#call" @click="CallProvider(provider)">{{ provider.tel }}</a>
              <font-awesome-icon
                icon="phone"
                :id="'dob' + provider.licensenum"
                class="icon"
              /><b>Expiration Date:</b><span>{{ provider.licenseexpdate }}</span>
            </td>
          </tr> -->
          <!-- <tr v-if="provider.state">
                    <td class="provider__info">
                    <font-awesome-icon icon="address-book" class="icon"/>
                    <b>jurisdiction:</b> <span :id="'state'+provider.licensenum">{{ provider.state }}</span>
                    </td>
                </tr> -->
          <!-- <tr v-if="provider.activestatus">
            <td class="provider__info">
              <font-awesome-icon icon="fax" class="icon" />
              <b>Active Status:</b> {{ provider.activestatus }}
            </td>
          </tr> -->
          <tr v-if="providerChild.checkstatus">
            <td class="provider__info">
              <font-awesome-icon :icon="['fas', 'fax']" class="icon" />
              <b>Status Check Date:</b>
              {{
                `${providerChild.checkstatus}, ${
                  providerChild.activestatus == "YES" ? "UNENCUMBERED" : "INVALID"
                }`
              }}
            </td>
          </tr>
          <tr v-if="providerChild.insuranceCompany">
            <td class="provider__info">
              <font-awesome-icon :icon="['fas', 'fax']" class="icon" />
              <b>Insurance Company: </b>
              <span v-if="!updatingInsurance">{{ `${providerChild.insuranceCompany}` }}</span>
              <input v-else v-model="insUpdate.insName" />
            </td>
          </tr>
          <tr v-if="providerChild.insuranceStart && providerChild.insuranceEnd">
            <td class="provider__info">
              <font-awesome-icon :icon="['fas', 'fax']" class="icon" />
              <b>Insurance Duration:</b>
              <span v-if="!updatingInsurance">{{
                `${providerChild.insuranceStart} to ${providerChild.insuranceEnd}`
              }}</span>
              <div v-else>
                <input type="date" v-model="insUpdate.insSt" /> to
                <input type="date" v-model="insUpdate.insEnd" />
              </div>
            </td>
          </tr>
          <tr v-if="providerChild.perIncidentAmnt || providerChild.annualAggAmnt">
            <td class="provider__info">
              <font-awesome-icon :icon="['fas', 'fax']" class="icon" />
              <b>Insurance Limits:</b>
              <span v-if="!updatingInsurance"
                >{{
                  `${
                    providerChild.perIncidentAmnt ? providerChild.perIncidentAmnt : "N/A"
                  } per incident, ${
                    providerChild.annualAggAmnt ? providerChild.annualAggAmnt : "N/A"
                  } annual aggregate`
                }}
              </span>
              <div v-else>
                <input type="number" v-model="insUpdate.insIncLim" /> per incident,
                <input type="number" v-model="insUpdate.insAnnLim" /> annual aggregate
              </div>
            </td>
          </tr>
          <tr>
            <td class="update__btns">
              <button
                v-if="!updatingInsurance"
                @click="updatingInsurance = true"
                class="update_btn"
                type="button"
              >
                Update Insurance
              </button>
              <button
                v-if="updatingInsurance"
                @click.prevent="saveInsuranceUpdate"
                class="save_btn"
                type="button"
              >
                Save changes
              </button>
              <button
                v-if="updatingInsurance"
                @click.prevent="cancelInsuranceUpdate"
                class="cancel_btn"
                type="button"
              >
                Cancel
              </button>
            </td>
          </tr>
        </div>
      </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else class="Mobile-container">
    <div class="Mobile-profile-photo"></div>
    <!-- <div
      class="Mobile-nurse-name-tab"
      style="
        background-color: #007bff;
        color: white;
        padding: 10px;
        border-radius: 5px;
        text-align: center;
        font-weight: bold;
      "
    >
      {{ `${provider.firstname} ${provider.lastname}, ${provider.licensetype}` }}
    </div> -->
    <div class="Mobile-accordion-content" style="max-height: none; margin-top: 10px">
      <div v-if="providerChild.primaryphone" class="Mobile-form-group">
        <font-awesome-icon :icon="['fas', 'phone']" class="icon" />
        <div class="Mobile-text">
          <label>Primary Number:</label>
          <span
            ><a :href="'tel:' + providerChild.primaryphone">{{
              providerChild.primaryphone
            }}</a></span
          >
        </div>
      </div>
      <div v-if="providerChild.secondaryphone" class="Mobile-form-group">
        <font-awesome-icon :icon="['fas', 'phone']" class="icon" />
        <div class="Mobile-text">
          <label>Secondary Number:</label>
          <span
            ><a :href="'tel:' + providerChild.secondaryphone">{{
              providerChild.secondaryphone
            }}</a></span
          >
        </div>
      </div>
      <div v-if="providerChild.email" class="Mobile-form-group">
        <font-awesome-icon :icon="['fas', 'envelope']" class="icon" />
        <div class="Mobile-text">
          <label>E-mail:</label>
          <span
            ><a :href="'mailto:' + providerChild.email">{{ providerChild.email }}</a></span
          >
        </div>
      </div>
      <div v-if="providerChild.addr1" class="Mobile-form-group">
        <font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon" />
        <div class="Mobile-text">
          <label>Address:</label>
          <span>{{
            `${providerChild.addr1}, ${providerChild.addr2}, ${
              providerChild.city
            }, ${providerChild.state.toUpperCase()}, ${providerChild.zip}`
          }}</span>
        </div>
      </div>
    </div>
    <button @click="showRemaining" class="Mobile-accordion">
      License/Insurance Information
    </button>
    <div class="Mobile-accordion-content" :id="'remainingInfo' + provider.pmid">
      <div class="Mobile-form-group">
        <font-awesome-icon :icon="['fas', 'file-pdf']" class="icon" />
        <div class="Mobile-text">
          <label>{{ `${providerChild.state} License #:` }}</label>
          <span>{{ `${providerChild.licensenum}, Exp. ${providerChild.licenseexpdate}` }}</span>
        </div>
      </div>
      <div class="Mobile-form-group">
        <font-awesome-icon :icon="['fas', 'calendar-check']" class="icon" />
        <div v-if="providerChild.checkstatus" class="Mobile-text">
          <label>Status Check Date: </label>
          <span>{{
            `${providerChild.checkstatus}, ${
              providerChild.activestatus == "YES" ? "UNENCUMBERED" : "INVALID"
            }`
          }}</span>
        </div>
      </div>
      <div class="Mobile-form-group">
        <font-awesome-icon :icon="['fas', 'file-pdf']" class="icon" />
        <div class="Mobile-text">
          <label>Insurance Company: </label>
          <span>{{ `${providerChild.insuranceCompany}` }}</span>
        </div>
      </div>
      <div class="Mobile-form-group">
        <font-awesome-icon :icon="['fas', 'calendar-alt']" class="icon" />
        <div class="Mobile-text">
          <label>Insurance Duration: </label>
          <span>{{ `${providerChild.insuranceStart} to ${providerChild.insuranceEnd}` }}</span>
        </div>
      </div>
      <div class="Mobile-form-group">
        <font-awesome-icon :icon="['fas', 'dollar-sign']" class="icon" />
        <div class="Mobile-text">
          <label>Insurance Limits: </label>
          <span>{{
            `${providerChild.perIncidentAmnt} per incident, ${providerChild.annualAggAmnt} annual aggregate`
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "CurrentNurseBio",
  data() {
    return {
      allProvs: null, // List of providers already saved for patient
      txtMsg: "",
      txtPhone: "", // Fax number of chosen physician
      updatingInsurance: false,
      insUpdate: {
        insName: "",
        insSt: "",
        insEnd: "",
        insIncLim: 0,
        insAnnLim: 0,
      },
      providerChild: this.provider
    };
  },
  props: {
    provider: Object,
  },
  beforeMount() {
    this.checkScreensize();
    this.insUpdate.insName = this.providerChild.insuranceCompany;
    this.insUpdate.insSt = this.providerChild.insuranceStart;
    this.insUpdate.insEnd = this.providerChild.insuranceEnd;
    this.insUpdate.insIncLim = this.providerChild.perIncidentAmnt;
    this.insUpdate.insAnnLim = this.providerChild.annualAggAmnt;
  },
  mounted() {},
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function () {
      return this.allData.patient;
    },
    manager: function () {
      return this.allData.manager;
    },
  },
  methods: {
    isMobile() {
      // console.log(this.provider);
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    showRemaining() {
      let dropdown = $("#remainingInfo" + this.provider.pmid);
      dropdown.slideToggle();
    },
    async saveInsuranceUpdate() {
      let content = {
        Insurance: {
          API_Meth: "SaveNewInsurance",
          accountnumber: this.providerChild.acountnumber,
          pid: this.providerChild.providerID,
          newName: this.insUpdate.insName,
          newStart: this.insUpdate.insSt,
          newEnd: this.insUpdate.insEnd,
          newIncLim: this.insUpdate.insIncLim,
          newAnnLim: this.insUpdate.insAnnLim,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.status == "Success") {
            this.providerChild.insuranceCompany = this.insUpdate.insName;
            this.providerChild.insuranceStart = this.insUpdate.insSt;
            this.providerChild.insuranceEnd = this.insUpdate.insEnd;
            this.providerChild.perIncidentAmnt = this.insUpdate.insIncLim;
            this.providerChild.annualAggAmnt = this.insUpdate.insAnnLim;
            this.updatingInsurance = false;
          } else {
            alert(res.data.status);
          }
        });
    },
    cancelInsuranceUpdate() {
      this.updatingInsurance = false;
      this.insUpdate.insName = this.providerChild.insuranceCompany;
      this.insUpdate.insSt = this.providerChild.insuranceStart;
      this.insUpdate.insEnd = this.providerChild.insuranceEnd;
      this.insUpdate.insIncLim = this.providerChild.perIncidentAmnt;
      this.insUpdate.insAnnLim = this.providerChild.annualAggAmnt;
    },
    checkScreensize() {
      let height = $(window).height;
      let width = $(window).width;
      //alert($(window).width);
      if ($(window).width > 760 && $(window).width <= 1024) {
        alert("Tableet");
      }
    },
    showEmailModule(event, provider, pid) {
      console.log(event.target.id + " " + "ShowEmailModule");
      console.log(event.target);
      console.log(pid);
      $("#emailcanvas" + pid).css("display", "block");
      let subject =
        "You have a message from" +
        " " +
        provider.firstname +
        " " +
        provider.lastname +
        ", PLease login into the Erriff Health Portal to view message.";
      $("#provemailsubject" + pid).val(subject);
      let message =
        "Dr. " +
        provider.firstname +
        ",please login to view your message from the Erriff Health EMR Portal.";
      $("#provid-emailmsg" + pid).val(message);
      console.log($(".emailcanvas").attr("class"));

      $("#emailcanvas" + pid).css("display", "block");
      //now lets bind the providers email address to the email input field
      console.log(provider.email);
      $("#providetomail" + pid).val(provider.email);
      console.log($("#emailcanvas" + pid).attr("id"));
    },
    closeOption(event) {
      $(event.target).closest(".m-option").css("display", "none");
    },
    closeDOption(event) {
      $(event.target).closest(".d-option").css("display", "none");
    },
    // Replaced by callProvider (?)
    // async CallProvider(provider) {
    //   if (!this.manager.phone1 && !this.manager.phone2) {
    //     alert(
    //       "You have no phone number associated with your account. Please visit your profile page and set one."
    //     );
    //   } else {
    //     let content = {
    //       Twilio: {
    //         API_Meth: "SendPhoneCall",
    //         from: this.manager.phone1 ? this.manager.phone1 : this.manager.phone2,
    //         callnumber: provider.tel ? provider.cell : provider.tel,
    //       },
    //     };
    //     await axios
    //       .post(CURR_API + "/tswebhook.php", content, {
    //         headers: { "Content-Type": "application/json;" },
    //       })
    //       .then((res) => {
    //         console.log(res);
    //         if (res.data.status != "") {
    //           alert("Connecting call...");
    //         } else {
    //           alert("Error connecting call.");
    //         }
    //       });
    //   }
    // },
    async CallProviderCell(event, pmid) {
      // console.log(event.target.id);
      // console.log(window.innerWidth);
      console.log("ID" + " " + pmid);
      if (window.innerWidth < 768) {
        $("#d-option" + pmid).css("display", "none");
        $("#m-option" + pmid).css("display", "flex");
      }
      if (window.innerWidth >= 1024) {
        $("#d-option" + pmid).css("display", "flex");
        $("#m-option" + pmid).css("display", "none");
      }
    },
    showTextProv(event, prvphone, pid, provid) {
      this.txtPhone = prvphone;
      console.log(this.txtPhone);
      console.log(event.target.id);
      // $("#d-option" + pid).css("display", "flex");
      $("#send-text-modal-" + pid).css("display", "flex");
      $("#modaltext" + pid).val(prvphone);
      $("#d-option" + provid).css("display", "none");
    },
    async VerifyNurse(provider) {
      // console.log(provider);
      const licensenumber = provider.licensenum;
      $("#desktopLicense" + licensenumber).removeAttr("href");
      $("#desktopLicense" + licensenumber).css("background-color", "#000000");
      $("#desktopLicense" + licensenumber).css("color", "#ffffff");
      // let licnum = $("#desktopLicense" + licensenumber).html();
      $("#desktopLicense" + licensenumber).html("...verifying");

      //grab info needed to verify
      let content = {
        NursyInfo: {
          API_Meth: "LookupNursesInfo",
          rnlicense: provider.licensenum, //$("#desktopLicense"+licensenumber).html(),
          jurisdiction: provider.state,
          ltype: provider.licensetype,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          $("#desktopLicense" + licensenumber).attr("href", "#verify");
          $("#desktopLicense" + licensenumber).css("background-color", "#ffffff");
          $("#desktopLicense" + licensenumber).css("color", "#0d6efd");
          $("#desktopLicense" + licensenumber).html(licensenumber);
          if (res.data != "") {
            if (res.data.status == "Result Not Found") {
              //lets try and get more specific on the update 
             
              if(res.data.msg && res.data.msg[0].ErrorId==4)
              {
                alert(res.data.msg[0].ErrorMessage);
              }
              else{
                 alert("No Result Found for licensnumber" + " " + licensenumber);
              }
             
            }
            for (var i = 0; i < res.data.length; i++) {
              console.log(i);
              console.log(res.data.length);
              console.log(res.data[i].LicenseType);
              console.log($("#ltype" + licensenumber).html());
              if (res.data[i].LicenseType == provider.licensetype) {
                if (
                  res.data[i].Active != "YES" ||
                  res.data[i].LicenseStatus == "SUSPENSION"
                ) {
                  
                  //lets check to see if they have been reinstated in the NurseLookUpRevision Object
                 
                  if (
                    res.data[i].NurseLookupDisciplines &&
                    res.data[i].NurseLookupDisciplines[i].NurseLookupRevisionReports &&
                    res.data[i].NurseLookupDisciplines[i].NurseLookupRevisionReports.length
                  ) {
                    // Iterate through NurseLookupRevisionReports
                   
                    for (
                      var t = 0;
                      t < res.data[i].NurseLookupDisciplines[i].NurseLookupRevisionReports.length;
                      t++
                    ) {
                      // Check if NurseLookupRevisionActions exists and has length
                      if (
                        res.data[i].NurseLookupDisciplines[i].NurseLookupRevisionReports[t]
                          .NurseLookupRevisionActions &&
                        res.data[i].NurseLookupDisciplines[i].NurseLookupRevisionReports[t]
                          .NurseLookupRevisionActions.length
                      ) {
                        // Iterate through NurseLookupRevisionActions
                       
                        for (
                          var r = 0;
                          r < res.data[i].NurseLookupDisciplines[i].NurseLookupRevisionReports[t]
                            .NurseLookupRevisionActions.length;
                          r++
                        ) {
                          // Check ActionDescription
                          if (
                            res.data[i].NurseLookupDisciplines[i].NurseLookupRevisionReports[t]
                              .NurseLookupRevisionActions[r].ActionDescription ==
                            "LICENSE RESTORED OR REINSTATED, COMPLETE"
                          ) {
                          
                            $("#vstatus2" + licensenumber).attr(
                              "class",
                              "col-sm-12 col-md-12 col-lg-12 status-active"
                            );
                            $("#vstatus2" + licensenumber).css("display", "block");
                            $("#vstatus" + licensenumber).css("display", "none");
                            alert("License Reinstated");
                          }
                        }
                      }
                    }
                  } else {
                    alert("License Not Active, please take action as needed.");
                    $("#vstatus" + licensenumber).css("display", "block");
                    $("#vstatus2" + licensenumber).css("display", "none");
                  }
                } else if (
                  res.data[i].Active == "YES" ||
                  res.data[i].LicenseStatus == "UNENCUMBERED"
                ) {
                  //its active
                  alert("License Active, no action needed.");
                  $("#vstatus2" + licensenumber).css("display", "block");
                  $("#vstatus" + licensenumber).css("display", "none");
                }
              }
            }
          } else {
            alert("Please verify at a later time.");
          }
        });
    },
    CancelUpdateNurse(event, licensnum) {
      //close the div section
      event.preventDefault();
      $("#nurseform" + licensnum).css("display", "none");
      $("#nursecard" + licensnum).slideDown("slow");
    },
    async UpdateNurse(event, license) {
      event.preventDefault();
      $("#updatenursebtn").attr("disabled", "disabled");
      let content = {
        ManageNurseList: {
          API_Meth: "Add_Nurse",
          ncsid: $("#nurseform" + license)
            .find("#nrnsbid")
            .val(),
          jurisdiction: $("#nurseform" + license)
            .find("#nrstate")
            .val(),
          subactioncode: "A", //required
          licensnum: $("#nurseform" + license)
            .find("#nrlicense")
            .val(),
          ltype: $("#nurseform" + license)
            .find("#nursetype")
            .val(),
          email: $("#nurseform" + license)
            .find("#nurseemail")
            .val(),
          primephone: $("#nurseform" + license)
            .find("#primephone")
            .val(),
          secondaryphone: $("#nurseform" + license)
            .find("#secphone")
            .val(),
          address1: $("#nurseform" + license)
            .find("#nraddress")
            .val(), //req
          address2: "",
          city: $("#nurseform" + license)
            .find("#nrcity")
            .val(), //req
          state: $("#nurseform" + license)
            .find("#nrstate")
            .val(), //req
          zip: $("#nurseform" + license)
            .find("#nrzip")
            .val(), //req
          lastfourssn: $("#nurseform" + license)
            .find("#nrsocial")
            .val(), //req
          bdayear: $("#nurseform" + license)
            .find("#nrdob")
            .val(), //req
          hospitalpracsetting: "21", //req
          hostpracsettingother: "",
          notficationenabled: "N", //req
          reminderenabled: "N", //req
          locationlist: "",
          recid: "",
          accountnumber: $("#nurseform" + license)
            .find("#nraccount")
            .val(),
          firstname: $("#nurseform" + license)
            .find("nursefname")
            .val(),
          lastname: $("#nurseform" + license)
            .find("#nurselname")
            .val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          $("#updatenursebtn").removeAttr("disabled");
          let jdata = res;
          console.log(jdata);
          if (jdata.data.status == "Nurse Added") {
            alert(
              "Nurse" +
                " " +
                $("#nursefname").val() +
                " " +
                $("#nurselname").val() +
                " Successfully Updated"
            );
            //now close SMS Canvas

            //lets now add them to our internal database

            this.UpdateInternalNurse(license);
          } else if (jdata.data.errors) {
            alert("Issue");
            alert(jdata.errors.ErrorMessage);
          }
        });
    },
    async UpdateInternalNurse(license) {
      let content = {
        ManageNurseList: {
          API_Meth: "InternalUpdateNurse",
          ncsid: $("#nurseform" + license)
            .find("#nrnsbid")
            .val(),
          jurisdiction: $("#nurseform" + license)
            .find("#nrstate")
            .val(),
          subactioncode: "A", //required
          licensnum: $("#nurseform" + license)
            .find("#nrlicense")
            .val(),
          ltype: $("#nurseform" + license)
            .find("#nursetype")
            .val(),
          email: $("#nurseform" + license)
            .find("#nurseemail")
            .val(),
          primearyphone: $("#nurseform" + license)
            .find("#primephone")
            .val(),
          secondaryphone: $("#nurseform" + license)
            .find("#secphone")
            .val(),
          address1: $("#nurseform" + license)
            .find("#nraddress")
            .val(), //req
          address2: "",
          city: $("#nurseform" + license)
            .find("#nrcity")
            .val(), //req
          state: $("#nurseform" + license)
            .find("#nrstate")
            .val(), //req
          zip: $("#nurseform" + license)
            .find("#nrzip")
            .val(), //req
          lastfourssn: $("#nurseform" + license)
            .find("#nrsocial")
            .val(), //req
          bdayear: $("#nurseform" + license)
            .find("#nrdob")
            .val(), //req
          hospitalpracsetting: "21", //req
          hostpracsettingother: "",
          notficationenabled: "Y", //req
          reminderenabled: "Y", //req
          locationlist: "",
          recid: "",
          accountnumber: $("#nurseform" + license)
            .find("#nraccount")
            .val(),
          firstname: $("#nurseform" + license)
            .find("#nursefname")
            .val(),
          lastname: $("#nurseform" + license)
            .find("#nurselname")
            .val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "Updated") {
            alert("Nurse infomration updated successfully!");
            //now close SMS Canvas
          } else {
            alert(res.message);
            console.log("Nurses not added successfully");
          }
        });
    },
    async callProvider(provider) {
      let fromNumber = ""
      if (this.manager){
        if (!this.manager.phone1 && !this.manager.phone2) {
          alert(
            "You have no phone number associated with your account. Please visit your profile page and set one."
          );
          return
        }
        else
          fromNumber = this.manager.phone1 ? this.manager.phone1 : this.manager.phone2
      }
      else if (this.patient) {
        if (!this.patient.phone1 && !this.patient.phone2) {
          alert(
            "You have no phone number associated with your account. Please visit your profile page and set one."
          );
          return
        }
        else
          fromNumber = this.patient.phone1 ? this.patient.phone1 : this.patient.phone2
      }
      else {
        alert("Contact administrator")
        return
      }
      let content = {
        Twilio: {
          API_Meth: "SendPhoneCall",
          from: fromNumber,
          callnumber: provider.primaryphone,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status != "") {
            alert("Connecting call...");
          } else {
            alert("Error connecting call.");
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
#nurseform28146329A {
  width: 635px;
  height: auto;
  display: flex;
  flex-direction: column;
}
.status-active {
  display: none;
  background-color: #70a50d;
  color: #ffffff;
  font-size: 17px;
}
.status-nonactive {
  display: none;
  background-color: #f12f4f;
  color: #ffffff;
  font-size: 17px;
}
.nurse-edit {
  display: none;
}
.btn-sec {
  display: flex;
}
#nurseform28146329A input[type="text"] {
  margin-bottom: 10px;
}
#nurseform28146329A input[type="date"] {
  margin-bottom: 10x;
}
#nurseform28146329A input[type="phone"] {
  margin-bottom: 10px;
}
$color-font: darken(#58595b, 10%);
table {
  text-align: left;
  width: 100%;
}

tr {
  font-size: 0.95em;
}

.table-container {
  padding: 1em 2em 1.5em;
  border-bottom: 1px solid lightgray;
}

.provider__avatar {
  width: 100px;
}

.provider__title {
  font-size: 1.5em;
}

.provider__info {
  color: $color-font;
  line-height: 1.8em;
}

.icon {
  margin-right: 0.5em;
}

.capitalize {
  text-transform: capitalize;
}
.nurse-edit {
  /*display:none;*/
}
@media only screen and (min-width: 1024px) {
  .table-container .m-flex {
    display: flex;
  }
  .m-align {
    text-align: left;
  }
  .table-container .m-option {
    display: none;
  }
  .x-close {
    height: 21px;
  }
  .option-item h4 {
    font-size: 16px;
    text-align: center;
  }
  .d-option {
    display: flex;
  }
  .m-option {
    display: none;
  }
  .slabel {
    margin-right: 15px;
  }
  .icon .mobileTel {
    display: none;
  }
  .icon .desktopTel {
    display: flex;
  }
}
@media screen and (min-width: 360px) {
  .m-flex {
    display: flex;
    flex-direction: column;
  }
  .m-align {
    text-align: center;
  }
  .m-option {
    display: flex;
    flex-direction: column;
  }
  .d-option {
    display: none;
  }
  .option-container {
    border-color: #0335;
    border-style: solid;
    border-width: 1px;
    padding: 15px 20px;
  }
  .option-item:last-child {
    margin-top: 12px;
  }
  .option-item h4 {
    font-size: 22px;
  }
  .x-close {
    margin-bottom: 0px;
    width: 100%;
    height: 42px;
    display: flex;
    flex-direction: row-reverse;
  }
  .m-itemclose {
    font-size: 20px;
    color: #000000;
  }
  .d-option {
    display: none;
    flex-direction: column;
    position: relative;
    /*left: 580px;
    z-index: 4000000;
    background-color: #fff;
    top: 300px;*/

    left: -180px;
    z-index: 4000000;
    background-color: #fff;
    top: 0px;
    width: 300px;
  }
  .m-option {
    display: none;
  }
  .icon.mobileTel {
    display: flex;
  }
  .icon.desktopTel {
    display: none;
  }
}
.Mobile-container {
  width: 100%;
  max-width: 100%;
  margin: auto;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-sizing: border-box;
}

.Mobile-profile-photo {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #ccc;
  // background-image: url("/assets/images/avatar-female.jpg");
  background-size: cover;
  background-position: center;
  margin: 0 auto 15px;
}

/* Accordion styles */
.Mobile-accordion {
  background-color: #007bff;
  color: white;
  cursor: pointer;
  padding: 10px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  font-size: 1em;
  transition: 0.4s;
  border-radius: 5px;
  margin-top: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Mobile-accordion:hover,
.Mobile-accordion:focus {
  background-color: #0056b3;
}

.Mobile-accordion-arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid white;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  transition: transform 0.2s ease;
}

.Mobile-accordion.active .Mobile-accordion-arrow {
  transform: rotate(90deg); /* Rotate to indicate expanded state */
}

.Mobile-accordion-content {
  padding: 0 15px;
  // max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s ease-out;
  background-color: #f7f7f7;
  margin-top: 10px;
  box-sizing: border-box;
}

.Mobile-accordion-content .Mobile-form-group {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #ddd;
}

.Mobile-accordion-content .Mobile-form-group:last-child {
  border-bottom: none;
}

.Mobile-form-group i {
  color: #007bff;
  margin-right: 10px;
  flex-shrink: 0;
}

.Mobile-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

.Mobile-form-group label {
  font-weight: bold;
  margin-bottom: 3px;
}

.Mobile-form-group span {
  text-align: left;
}

/* Media Queries */

@media (max-width: 575.98px) {
  .Mobile-container {
    padding: 8px;
  }
  .Mobile-form-group {
    flex-direction: row;
    align-items: flex-start;
    padding-left: 0;
    padding-right: 0;
  }
  .Mobile-form-group label {
    margin-left: 0;
    width: 100%;
    margin-bottom: 5px;
  }
  .Mobile-form-group i {
    margin-bottom: 5px;
  }
}
</style>
